import { useTranslation } from 'react-i18next';
import Card from '../atoms/Card';
import Eyebrow from '../atoms/Eyebrow';

// Welcome variant shown to first-run users (sessions=[] AND trial_used=false).
// Recaps what a council is so the "Start council" CTA isn't a leap of faith.
// PR-UX-01 70/30 · 4 short bullets, no scroll.
// PR-UX-05 JTBD · maps to JT-05 ("I'm new and skeptical").
export default function WelcomeCard() {
  const { t } = useTranslation();
  const bullets = [
    t('dash.welcome.bullet1'),
    t('dash.welcome.bullet2'),
    t('dash.welcome.bullet3'),
    t('dash.welcome.bullet4'),
  ];
  return (
    <Card padding="loose" className="max-w-2xl mb-6 bg-paper border-azure/30">
      <Eyebrow tone="azure" className="mb-3">{t('dash.welcome.eyebrow')}</Eyebrow>
      <h2 className="font-serif text-2xl font-medium mb-3">
        {t('dash.welcome.title')}
      </h2>
      <ul className="space-y-2 text-base text-ink-2">
        {bullets.map((b, i) => (
          <li key={i} className="flex gap-3">
            <span className="font-mono text-[11px] tracking-meta uppercase text-azure-700 shrink-0 w-6 pt-1">
              {String(i + 1).padStart(2, '0')}
            </span>
            <span>{b}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
